import PropTypes from "prop-types";
import React from "react";

export const Ticket = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M5.33464 26.6667C4.6013 26.6667 3.97375 26.4058 3.45197 25.884C2.9293 25.3614 2.66797 24.7334 2.66797 24V18.6667C3.4013 18.6667 4.0293 18.4054 4.55197 17.8827C5.07375 17.3609 5.33464 16.7334 5.33464 16C5.33464 15.2667 5.07375 14.6387 4.55197 14.116C4.0293 13.5943 3.4013 13.3334 2.66797 13.3334V8.00004C2.66797 7.26671 2.9293 6.63915 3.45197 6.11737C3.97375 5.59471 4.6013 5.33337 5.33464 5.33337H26.668C27.4013 5.33337 28.0293 5.59471 28.552 6.11737C29.0737 6.63915 29.3346 7.26671 29.3346 8.00004V13.3334C28.6013 13.3334 27.9733 13.5943 27.4506 14.116C26.9289 14.6387 26.668 15.2667 26.668 16C26.668 16.7334 26.9289 17.3609 27.4506 17.8827C27.9733 18.4054 28.6013 18.6667 29.3346 18.6667V24C29.3346 24.7334 29.0737 25.3614 28.552 25.884C28.0293 26.4058 27.4013 26.6667 26.668 26.6667H5.33464ZM5.33464 24H26.668V20.6C25.8457 20.1112 25.196 19.4614 24.7186 18.6507C24.2404 17.8392 24.0013 16.9556 24.0013 16C24.0013 15.0445 24.2404 14.1609 24.7186 13.3494C25.196 12.5387 25.8457 11.8889 26.668 11.4V8.00004H5.33464V11.4C6.15686 11.8889 6.80708 12.5387 7.2853 13.3494C7.76263 14.1609 8.0013 15.0445 8.0013 16C8.0013 16.9556 7.76263 17.8392 7.2853 18.6507C6.80708 19.4614 6.15686 20.1112 5.33464 20.6V24ZM16.0013 22.6667C16.3791 22.6667 16.696 22.5387 16.952 22.2827C17.2071 22.0276 17.3346 21.7112 17.3346 21.3334C17.3346 20.9556 17.2071 20.6387 16.952 20.3827C16.696 20.1276 16.3791 20 16.0013 20C15.6235 20 15.3071 20.1276 15.052 20.3827C14.796 20.6387 14.668 20.9556 14.668 21.3334C14.668 21.7112 14.796 22.0276 15.052 22.2827C15.3071 22.5387 15.6235 22.6667 16.0013 22.6667ZM16.0013 17.3334C16.3791 17.3334 16.696 17.2054 16.952 16.9494C17.2071 16.6943 17.3346 16.3778 17.3346 16C17.3346 15.6223 17.2071 15.3054 16.952 15.0494C16.696 14.7943 16.3791 14.6667 16.0013 14.6667C15.6235 14.6667 15.3071 14.7943 15.052 15.0494C14.796 15.3054 14.668 15.6223 14.668 16C14.668 16.3778 14.796 16.6943 15.052 16.9494C15.3071 17.2054 15.6235 17.3334 16.0013 17.3334ZM16.0013 12C16.3791 12 16.696 11.872 16.952 11.616C17.2071 11.3609 17.3346 11.0445 17.3346 10.6667C17.3346 10.2889 17.2071 9.97204 16.952 9.71604C16.696 9.46093 16.3791 9.33337 16.0013 9.33337C15.6235 9.33337 15.3071 9.46093 15.052 9.71604C14.796 9.97204 14.668 10.2889 14.668 10.6667C14.668 11.0445 14.796 11.3609 15.052 11.616C15.3071 11.872 15.6235 12 16.0013 12Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 32 32",
    };
  }
};

Ticket.displayName = "TicketIcon";

Ticket.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Ticket.defaultProps = { role: "img" };
